import React from 'react';
import { Box } from '@mui/material';

const Frames = ({ src, title, onLoad }) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '8px',
                overflow: 'hidden',
            }}
        >
            <iframe
                src={src}
                title={title || 'Content Frame'}
                width="100%"
                height="100%"
                frameBorder="0"
                allowFullScreen
                onLoad={onLoad}
                style={{
                    border: 'none',
                    borderRadius: '8px',
                }}
            />
        </Box>
    );
};

export default Frames;
